<div [class]="options.cssClass" class="photo-gallery-component" #galleryComponent>
    <div class="photo-gallery-container flex-container">
        <div class="photo-gallery-wrapper flex-container flex-column">

            <div class="actions-container custom-actions" *ngIf="isEditable && options?.customActions && options?.customActions.length > 0">
                <div *ngFor="let action of options.customActions"  class="select-action-container" (click)="customActionEvent(action)">
                    <i [class]="action.icon"></i>
                </div>
            </div>

            <div class="actions-container">

                <div *ngIf="options?.hasSelected" class="select-action-container" (click)="selectImage()">
                    <i [ngClass]="{
                        'fas fa-check-square': currentAlbumImage && currentAlbumImage.selected,
                        'far fa-square': !(currentAlbumImage && currentAlbumImage.selected)
                    }"></i>
                </div>
                <div class="select-action-container"
                    *ngIf="isEditable && currentAlbumImage && currentAlbumImage.showDelete"
                    (click)="deleteImage()">
                    <i class="fas fa-trash-alt"></i>
                </div>
            </div>


            <div class="flex-container arrows-wrapper">
                <div class="arrow-left-wrapper">
                    <div (click)="prev()"
                        aria-hidden="true"
                        class="ngx-gallery-icon ngx-gallery-arrow arrow-left"
                        [ngClass]="{
                            'disable-arrow': !this.album || (this.album && this.album.length <= 1)
                        }">
                        <i class="ngx-gallery-icon-content fas fa-chevron-left"></i>
                    </div>
                </div>
                <div>
                    <div (click)="next()"
                        aria-hidden="true"
                        class="ngx-gallery-icon ngx-gallery-arrow arrow-right"
                        [ngClass]="{
                            'disable-arrow': !this.album || (this.album && this.album.length <= 1)
                        }">
                        <i class="ngx-gallery-icon-content fas fa-chevron-right"></i>
                    </div>
                </div>
            </div>

            <div class="photo-wrapper">
                <div class="photo-container">
                    <div class="wrapper-spinner" *ngIf="showLoading">
                        <cv-loader></cv-loader>
                    </div>
                    <div class="render-content" #sceneContainer>
                        <img class="img-responsive"
							*ngIf="currentAlbumImage"
							[ngClass]="{'openPreview' : options.showPreview }"
                            [src]="previewPhoto"
                            (click)="openPreview()"
                            (load)="onImageLoad()"
                            (error)="onImageError()">
                    </div>
                </div>
                <div class="paginator flex-container" *ngIf="!showLoading && (options?.showDescription || options?.showCounters)">
                    <div class="section-pag-name" 
						*ngIf="options?.showDescription"
                        [innerHTML]="album[currentIndexAlbumSelected]?.imageDescription">
                    </div>
                    <div class="section-pag-counter" *ngIf="options?.showCounters">
                        <i class="fas fa-image"></i>
                        {{ currentIndexAlbumSelected + 1}} / {{ album ? album.length : 0}}
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>